module.exports = __webpack_public_path__ + "img/FPT05.02b41e8d.svg";